// extracted by mini-css-extract-plugin
export var divider = "education-module--divider--FIV-l";
export var row = "education-module--row--CPbbB";
export var title = "education-module--title--sdljl";
export var desc = "education-module--desc--Wj0hF";